module.exports = __webpack_public_path__ + "partylineManage/img/tsLogoGray.eadac983.png";